import { fetchWithRetry } from '@/utils/fetchWithRetry';

/**
 * Unauthenticated API fetch for public/client-facing endpoints (e.g. the
 * profiler questionnaire reached via a shareable /profiler/:slug link, with no
 * Auth0 session). Mirrors apiFetch but never attaches a bearer token.
 *
 * @see app/api/client.ts for the authenticated variant.
 */
const API_URL = import.meta.env.VITE_PRO_BACKEND_API_URL;

type ApiInit = Omit<RequestInit, 'body'> & { body?: unknown };

export async function publicApiFetch(
    path: string,
    init: ApiInit = {}
): Promise<Response> {
    const { body, headers, ...rest } = init;
    const finalHeaders = new Headers(headers);

    let finalBody: BodyInit | undefined;
    if (body !== undefined) {
        finalBody = JSON.stringify(body);
        if (!finalHeaders.has('Content-Type')) {
            finalHeaders.set('Content-Type', 'application/json');
        }
    }

    return fetchWithRetry(`${API_URL}${path}`, {
        ...rest,
        headers: finalHeaders,
        body: finalBody,
    });
}
